// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"0b5bb980","246":"45200a8a","347":"408272fd","787":"42266d5a","856":"f86b1e3c","896":"bf6ddd52","995":"0990373e"}[chunkId] + ".chunk.js";
};